"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_material_ui_form_validator_1 = require("react-material-ui-form-validator");
var AuthorizeService_1 = require("../api-authorization/AuthorizeService");
var CircularProgress_1 = require("@material-ui/core/CircularProgress");
var InputLabel_1 = require("@material-ui/core/InputLabel");
var MenuItem_1 = require("@material-ui/core/MenuItem");
function FormTypeValidator(props) {
    var _this = this;
    var value = props.value, onChange = props.onChange;
    var _a = React.useState([]), list = _a[0], setList = _a[1];
    var _b = React.useState(true), loading = _b[0], setLoading = _b[1];
    React.useEffect(function () {
        getList();
    }, []);
    var getList = function () { return __awaiter(_this, void 0, void 0, function () {
        var token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AuthorizeService_1.default.getAccessToken()];
                case 1:
                    token = _a.sent();
                    setLoading(true);
                    fetch("Forms/GetFormTypes", {
                        headers: !token ? { 'Content-Type': 'application/json; charset=utf-8' } : { 'Authorization': "Bearer " + token, 'Content-Type': 'application/json; charset=utf-8' },
                    }).then(function (response) { return response.json(); }).then(function (data) {
                        setList(data);
                        setLoading(false);
                    }).catch(function (error) {
                        setLoading(false);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(InputLabel_1.default, null, "Form"),
        React.createElement(react_material_ui_form_validator_1.SelectValidator, { name: "formType", variant: "outlined", margin: "normal", fullWidth: true, value: value !== null && value !== void 0 ? value : '', validators: ['required'], errorMessages: ['This field is required'], onChange: onChange, InputProps: {
                disabled: loading,
                startAdornment: (React.createElement(React.Fragment, null, loading ? React.createElement(CircularProgress_1.default, { size: 20 }) : null))
            } }, list.map(function (item) {
            return React.createElement(MenuItem_1.default, { key: item.key, value: item.key }, item.value);
        }))));
}
exports.default = FormTypeValidator;
//# sourceMappingURL=FormTypeDropdown.js.map